const CATEGORIES = [
  { value: 'PZWL', label: '测压管', type: '0601' },
  { value: 'SPPR', label: '渗流压力', type: '0602' },
  { value: 'ST', label: '应变', type: '0603' },
  { value: 'SINGLE_DISPLACEMENT', label: '单点位移' },
  { value: 'MULTI_DISPLACEMENT', label: '多点位移' }
];
const DIRECTIONS = [
  { value: '0604', label: '水平位移X向' },
  { value: '0605', label: '水平位移Y向' },
  { value: '0606', label: '垂直位移' }
];

function isDisplacement(category) {
  return category === 'SINGLE_DISPLACEMENT' || category === 'MULTI_DISPLACEMENT';
}

function stationTypes(station) {
  const types = Array.isArray(station.mstp) ? station.mstp : String(station.mstp || '').split(',');
  return types.map(value => String(value).trim()).filter(Boolean);
}

function normalizeStations(records) {
  const stations = new Map();
  (Array.isArray(records) ? records : []).forEach(record => {
    if (!record || record.mpcd == null || record.mpcd === '') return;
    const mpcd = String(record.mpcd);
    const previous = stations.get(mpcd);
    const types = stationTypes(record);
    stations.set(mpcd, {
      mpcd,
      mpnm: record.mpnm || (previous && previous.mpnm) || '',
      mstp: Array.from(new Set((previous ? previous.mstp : []).concat(types)))
    });
  });
  return Array.from(stations.values());
}

function filterStations(stations, category, directions) {
  const definition = CATEGORIES.find(item => item.value === category);
  if (!definition) return [];
  const types = definition.type ? [definition.type] : category === 'MULTI_DISPLACEMENT'
    ? directions.slice(0, 1) : DIRECTIONS.map(item => item.value);
  return stations.filter(station => stationTypes(station).some(type => types.includes(type)));
}

function reconcileSelection(stations, category, mpcds, directions, autoSelect) {
  let nextDirections = directions.filter(value => DIRECTIONS.some(item => item.value === value));
  if (category === 'MULTI_DISPLACEMENT') nextDirections = [nextDirections[0] || '0604'];
  const options = filterStations(stations, category, nextDirections);
  let selected = mpcds.filter(mpcd => options.some(station => station.mpcd === mpcd));
  if (category === 'SINGLE_DISPLACEMENT') selected = selected.slice(0, 1);
  if (!selected.length && autoSelect && options.length) selected = [options[0].mpcd];
  if (category === 'SINGLE_DISPLACEMENT') {
    const station = options.find(item => item.mpcd === selected[0]);
    const supported = station ? stationTypes(station) : [];
    nextDirections = nextDirections.filter(value => supported.includes(value));
    if (!nextDirections.length && station) {
      const first = DIRECTIONS.find(item => supported.includes(item.value));
      if (first) nextDirections = [first.value];
    }
  } else if (!isDisplacement(category)) {
    nextDirections = [];
  }
  return { mpcds: selected, directions: nextDirections };
}

function pad(value) { return String(value).padStart(2, '0'); }

function formatDate(date, withTime) {
  const day = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  return withTime ? day + ' ' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds()) : day;
}

function defaultDateRange(now) {
  const end = now || new Date();
  return [formatDate(new Date(end.getTime() - 30 * 86400000), true), formatDate(end, true)];
}

// Explicit local parsing also rejects impossible dates instead of normalizing them.
function parseTime(value, period) {
  if (typeof value !== 'string') return null;
  const pattern = period === 'DAY' ? /^(\d{4})-(\d{2})-(\d{2})$/
    : /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})$/;
  const match = value.match(pattern);
  if (!match) return null;
  const parts = match.slice(1).map(Number);
  const [year, month, day, hour = 0, minute = 0, second = 0] = parts;
  const date = new Date(year, month - 1, day, hour, minute, second);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day ||
      date.getHours() !== hour || date.getMinutes() !== minute || date.getSeconds() !== second) return null;
  return date.getTime();
}

function validateRequest(request) {
  if (!CATEGORIES.some(item => item.value === request.category)) return '请选择监测类型';
  if (!['MONITOR', 'DAY'].includes(request.period)) return '请选择监测或日数据';
  if (!request.mpcds.length) return '请选择测站';
  if (request.category === 'SINGLE_DISPLACEMENT' && request.mpcds.length !== 1) return '单点位移只能选择一个测站';
  if (isDisplacement(request.category)) {
    if (!request.directions.length) return '请选择位移方向';
    if (request.directions.some(value => !DIRECTIONS.some(item => item.value === value))) return '位移方向无效';
    if (request.category === 'MULTI_DISPLACEMENT' && request.directions.length !== 1) return '多点位移只能选择一个方向';
  }
  const start = parseTime(request.startTime, request.period);
  const end = parseTime(request.endTime, request.period);
  if (start === null || end === null) return '请选择完整、有效的起止时间';
  if (start > end) return '开始时间不能晚于结束时间';
  if (end - start > 365 * 86400000) return '查询时间间隔需小于一年！';
  return '';
}

function normalizeSeriesData(data) {
  return (Array.isArray(data) ? data : []).filter(item => {
    return Array.isArray(item) && typeof item[0] === 'string' &&
      (parseTime(item[0], 'MONITOR') !== null || parseTime(item[0], 'DAY') !== null);
  }).map(item => {
    const value = item[1] === null || item[1] === undefined || item[1] === '' ? null : Number(item[1]);
    return [item[0], value !== null && Number.isFinite(value) ? value : null];
  }).sort((a, b) => a[0].localeCompare(b[0]));
}

function buildChartOption(category, series) {
  const order = { measurement: 0, reservoir: 1 };
  const selected = (Array.isArray(series) ? series : []).filter(item => item && !['rain', 'temperature'].includes(item.kind))
    .slice().sort((a, b) => (order[a.kind] || 0) - (order[b.kind] || 0));
  const axes = [];
  const axisKeys = [];
  const colors = ['#5470C6', '#91CC75', '#EE6666', '#73C0DE', '#9A60B4', '#FC8452', '#3BA272'];
  const waterAxis = category === 'PZWL' || category === 'SPPR';
  const chartSeries = selected.map((item, index) => {
    const kind = item.kind || 'measurement';
    const unit = item.unit || '';
    const key = kind === 'reservoir' && !waterAxis ? 'reservoir' : 'measurement';
    let axisIndex = axisKeys.indexOf(key);
    if (axisIndex < 0) {
      axisIndex = axes.length;
      axisKeys.push(key);
      const name = key === 'reservoir' || waterAxis ? '水位(m)'
          : category === 'ST' ? '应变' + (unit ? '(' + unit + ')' : '') : '位移(mm)';
      axes.push({
        type: 'value', name, position: axisIndex === 0 ? 'left' : 'right',
        nameTextStyle: { align: axisIndex === 0 ? 'left' : 'right' },
        offset: axisIndex > 1 ? (axisIndex - 1) * 66 : 0,
        scale: true,
        axisLine: { show: true }, axisLabel: { formatter: '{value}' },
        splitLine: { show: axisIndex === 0, lineStyle: { color: '#edf0f4' } }
      });
    }
    const color = kind === 'reservoir' ? '#43b7b1' : colors[index % colors.length];
    const data = normalizeSeriesData(item.data);
    const validPoints = data.filter(point => point[1] !== null).length;
    const showPoints = validPoints > 0 && validPoints <= 100;
    return {
      name: item.name, type: 'line', yAxisIndex: axisIndex,
      data, connectNulls: false,
      showSymbol: showPoints, showAllSymbol: showPoints, symbol: 'circle', symbolSize: 4, smooth: true,
      itemStyle: { color }, lineStyle: { color, width: 1.8 }
    };
  });
  if (!axes.length) axes.push({ type: 'value', scale: true });
  return {
    animation: false,
    tooltip: { trigger: 'axis', confine: true, axisPointer: { type: 'cross' } },
    legend: { type: 'scroll', top: 8, left: 16, right: 16 },
    grid: { left: 28, right: axes.length > 2 ? 100 : 28, top: 64, bottom: 24, containLabel: true },
    xAxis: { type: 'time', boundaryGap: false, axisTick: { alignWithLabel: true } },
    yAxis: axes, series: chartSeries,
    toolbox: {
      show: true, right: 8, feature: { dataZoom: { yAxisIndex: 'none', iconStyle: { opacity: 0 } } }
    }
  };
}

function displayValue(value) {
  return value === null || value === undefined || value === '' ? '--' : String(value);
}

function downloadFilename(disposition, fallback) {
  const encoded = String(disposition || '').match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  const plain = String(disposition || '').match(/filename\s*=\s*(?:"([^"]+)"|([^;]+))/i);
  const candidate = encoded ? encoded[1] : plain ? plain[1] || plain[2] : '';
  if (!candidate) return fallback;
  try { return decodeURIComponent(candidate.trim()); } catch (error) { return candidate.trim(); }
}

module.exports = {
  CATEGORIES, DIRECTIONS, isDisplacement, stationTypes, normalizeStations, filterStations,
  reconcileSelection, defaultDateRange, parseTime, validateRequest, normalizeSeriesData,
  buildChartOption, displayValue, downloadFilename
};
